import React, { FunctionComponent, useLayoutEffect } from 'react';

import { GRID_VIEW } from '@yandex-360/telemost-sdk';
import { Session } from '@yandex-video-platform/goloom-sdk';
import { noop } from 'lodash';
import { useSelector } from 'react-redux';

import { useDocumentPictureInPictureContext } from '../../../../../../shared/components/document-pip';
import { getIsVideoShouldBeMirrored } from '../../../../../../shared/features/settings';
import { useActions } from '../../../../../../shared/hooks';
import { GRID_ITEM_RATIO } from '../../../../constants';
import { SlotsRenderer } from '../../../goloom-video-grid/components/slots-renderer';
import {
    selectPiPGridCurrentPage,
    selectPiPGridMaxDisplayParticipants,
    selectShowNextPiPGridPageButton,
    selectShowPrevPiPGridPageButton,
} from '../../selectors';
import { nextPiPGridPageAction, prevPiPGridPageAction, resetPiPGrid } from '../../slice';

export interface PiPGoloomVideoGridProps {
    session: Session;
}

export const PiPGoloomVideoGrid: FunctionComponent<PiPGoloomVideoGridProps> = ({ session }) => {
    const { onPrevPageClick, onNextPageClick, resetPiPGridState } = useActions({
        onPrevPageClick: prevPiPGridPageAction,
        onNextPageClick: nextPiPGridPageAction,
        resetPiPGridState: resetPiPGrid,
    });

    const { pipWindow } = useDocumentPictureInPictureContext();
    const maxDisplayParticipants = useSelector(selectPiPGridMaxDisplayParticipants);
    const currentPage = useSelector(selectPiPGridCurrentPage);
    const showPrevPageButton = useSelector(selectShowPrevPiPGridPageButton);
    const showNextPageButton = useSelector(selectShowNextPiPGridPageButton);
    const isMirrorVideo = useSelector(getIsVideoShouldBeMirrored);

    useLayoutEffect(() => {
        return () => {
            resetPiPGridState();
        };
    }, [resetPiPGridState]);

    return (
        <SlotsRenderer
            session={session}
            ResizeObserverCtor={(pipWindow as Window & { ResizeObserver: typeof ResizeObserver }).ResizeObserver}
            gridView={GRID_VIEW.DEFAULT}
            itemRatio={GRID_ITEM_RATIO.DEFAULT}
            maxDisplayParticipants={maxDisplayParticipants}
            maxSlotsCount={maxDisplayParticipants}
            currentPage={currentPage}
            onPrevPageClick={onPrevPageClick}
            onNextPageClick={onNextPageClick}
            showPrevPageButton={showPrevPageButton}
            showNextPageButton={showNextPageButton}
            onResize={noop}
            isMirrorVideo={isMirrorVideo}
            shouldRenderInviteBlock={false}
            needShowSelfScreenSharing={false}
            needShowMyVideo
        />
    );
};
